import { combineReducers } from "redux";

import globalReducer from "@/store/reducers/globalReducer";
import userReducer from "@/store/reducers/userReducer";
import mqttReducer from "@/store/reducers/mqttReducer";

export default combineReducers({
    global: globalReducer,
    user: userReducer,
    mqtt: mqttReducer,
});